import RoleActionButton from './RoleActionButton';

type CTASectionProps = {
  onBorrowerClick: () => void;
  onInvestorClick: () => void;
};

export default function CTASection({ onBorrowerClick, onInvestorClick }: CTASectionProps) {
  return (
    <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 flex flex-col justify-start items-center gap-6">
      <div className="w-full max-w-[1090px] p-6 sm:p-8 bg-gradient-to-l from-[#CFD9FF]/15 to-[#FFF0DE]/15 overflow-hidden rounded-2xl lg:rounded-3xl border border-gray-200 flex flex-col justify-center items-center gap-6 relative h-[420px]">
        {/* Target Icon (left, mirrored horizontally) */}
        <img
          src="/target_icon.png"
          className="absolute left-[-120px] top-1/2 -translate-y-1/2 w-[445px] h-[445px] pointer-events-none z-[1] scale-x-[-1]"
        />
        {/* Bar Chart Icon (right) */}
        <img
          src="/barchart_icon.png"
          className="absolute right-[-70px] top-1/2 -translate-y-1/2 w-[445px] h-[445px] pointer-events-none z-[1]"
        />
        <div className="w-full text-center text-black font-normal text-[clamp(24px,6vw,32px)] break-words z-[2]">
          Start building your wealth today
        </div>
        <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-2 z-[2]">
          <RoleActionButton
            label="Borrow"
            icon="/icons.svg"
            iconAlt="Handshake icon"
            variant="primary"
            onClick={onBorrowerClick}
          />
          <RoleActionButton
            label="Invest"
            icon="/invest.svg"
            iconAlt="Investment icon"
            variant="secondary"
            onClick={onInvestorClick}
          />
        </div>
      </div>
    </div>
  );
}
